'use client'

import { down } from 'styled-breakpoints'
import styled, { css } from 'styled-components'
import { Image } from '@/components/v2/atoms/image/image'

export const ArticleCard = styled.div`
  display: block;
  height: 100%;
  width: 100%;
  position: relative;
`

export const ArticleCardContent = styled.div`
  max-width: 320px;
  position: absolute;
  left: 22px;
  bottom: 22px;
  height: auto;

  ${down('md')} {
    max-width: 88%;
  }
`

export const ArticleCardTitle = styled.div`
  ${({ theme: { base } }) => `
    color: #000000;
    background: #FFFFFF;
  `}
  width: 100%;
  font-size: 22px;
  line-height: 26px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 10px 14px;

  ${down('md')} {
    font-size: 20px;
    line-height: 24px;
  }
`

export const ArticleCardChip = styled.div`
  ${({ theme: { base } }) => `
    color: #FFFFFF;
    background: #000000;
  `}

  display: inline-block;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  padding: 10px 14px;
`

export const ArticleCardFavoriteIconContainer = styled.div`
  position: absolute;
  right: 18px;
  top: 18px;
  z-index: 1;
`

const favouriteIconCSS = css`
  ${({
    theme: {
      base: { grey },
    },
  }) => `
  color:${'#ffffff'};
`}
  font-size: 24px;
  padding: 10px;
`

export const ArticleImage = styled(Image)`
  object-fit: fill;
  max-width: 100%;
  max-height: 100%;

  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;

  ${down('md')} {
    height: 100%;
  }
`

export const ArticleImageContainer = styled.div`
  width: 100%;

  aspect-ratio: 376/474;
  overflow: hidden;
`
